/**
 * Datalog / 로그 다운로드 API 에러 → i18n 키만 담은 ErrorMessage
 */

import {
  getBackendI18nKeyFromResponse,
  getHttpStatus,
  getServerMessage,
  isNetworkError,
  looksLikeI18nKey,
  normalizeBackendI18nKey,
} from './apiError';
import type { ErrorMessage } from './types';

const DATALOG_ERRORS = {
  GENERIC: {
    title: 'datalog:logDownloadFailed',
    message: 'datalog:logRequestFailed',
    type: 'error' as const,
  },
} as const;

export function parseDatalogApiError(error: unknown): ErrorMessage {
  if (!error) {
    return DATALOG_ERRORS.GENERIC;
  }

  if (isNetworkError(error)) {
    return {
      title: 'auth:network_error',
      message: 'auth:network_error_message',
      type: 'error',
    };
  }

  // 409: 이전 로그가 아직 처리(파싱) 중이라 요청을 막은 것 — 실패가 아니라 대기 안내
  if (getHttpStatus(error) === 409) {
    return {
      title: 'datalog:logProcessingTitle',
      message: 'datalog:log_processing',
      type: 'warning',
    };
  }

  const fromBackend = getBackendI18nKeyFromResponse(error);
  if (fromBackend && looksLikeI18nKey(fromBackend)) {
    return {
      title: 'datalog:logDownloadFailed',
      message: normalizeBackendI18nKey(fromBackend),
      type: 'error',
    };
  }

  const rawMsg = getServerMessage(error);
  if (rawMsg && looksLikeI18nKey(rawMsg)) {
    return {
      title: 'datalog:logDownloadFailed',
      message: normalizeBackendI18nKey(rawMsg),
      type: 'error',
    };
  }

  switch (getHttpStatus(error)) {
    case 403:
      return {
        title: 'datalog:logDownloadFailed',
        message: 'datalog:logRequestFailed',
        type: 'error',
      };
    case 404:
      return {
        title: 'datalog:logDownloadFailed',
        message: 'datalog:logRequestFailed',
        type: 'error',
      };
    case 500:
      return {
        title: 'datalog:logDownloadFailed',
        message: 'datalog:logRequestFailed',
        type: 'error',
      };
    default:
      return DATALOG_ERRORS.GENERIC;
  }
}
